"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _isBrowser = _interopRequireDefault(require("../../utils/is-browser"));
require("./layer.css");
var _excluded = ["children", "className", "isOpen", "targetElement"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Layer uses React's built in portal method to create a visual stacking layer in the DOM
 * outside the React application. It creates a fixed position full screen element
 * that would commonly be used for creating modal windows, dialogs, and overlays.
 *
 * By default, it will append itself (and children) to the body element, but can optionally
 * accept another element as the target.
 */
var Layer = function Layer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$targetElement = _ref.targetElement,
    targetElement = _ref$targetElement === void 0 ? _isBrowser["default"] ? document.body : undefined : _ref$targetElement,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line no-console
  console.warn('Deprecation warning: This component, Layer, is deprecated and will be removed in a future version. Please see the updated Pattern Library documentation to use the newer ModalProvider.');
  if (!isOpen || !children || !targetElement) {
    return null;
  }
  return (
    /*#__PURE__*/
    // react-docgen does not recognize this as a component w/o wrapping in a fragment
    _react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_reactDom["default"].createPortal(/*#__PURE__*/_react["default"].createElement("div", _extends({
      className: "sb-layer ".concat(className || '')
    }, otherProps), children), targetElement))
  );
};
Layer.displayName = 'Layer';
Layer.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content that will appear in the Layer
   */
  children: _propTypes["default"].any,
  /**
   * Indicates whether the Layer should be rendered or not
   */
  isOpen: _propTypes["default"].bool,
  /**
   * The DOM element to append the Layer to; defaults to the body element
   */
  targetElement: function targetElement(props, propName, componentName) {
    // Custom prop check to avoid exception issue when using SSR & PropTypes.instanceOf(Element)
    // due to Element being null
    var propValue = props[propName];
    if (!_isBrowser["default"] || !propValue) {
      return;
    }

    // check whether the provided value is a DOM element
    // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    if (propValue.nodeType !== Node.ELEMENT_NODE) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Validation failed. Expecting a DOM element."));
    }
  }
} : {};
var _default = exports["default"] = Layer;